/* eslint-disable indent */
import React, { Fragment } from 'react';
import Slider from 'react-slick';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import ImageChecker from './ImageChecker';

const ImageSlider = observer(
    ({
        sliderRef,
        singleImageSrc,
        singleFileType,
        multipleImages,
        isMultipleImages,
        folder,
        className,
        classNameSlider = 'poi-slider',
    }) => {
        const ArrowButton = ({ direction, onClick }) => (
            <button
                type="button"
                onClick={onClick}
                className={`absolute ${
                    direction === 'prev'
                        ? 'left-0 ml-[24px]'
                        : 'right-0 mr-[24px]'
                } top-[400px] w-[56px] h-[56px] bg-black bg-opacity-30 backdrop-blur-lg flex justify-center items-center z-30`}
                style={{
                    boxShadow:
                        '0px 40px 30px rgba(0, 0, 0, 0.05), inset 0px 1px 1px rgba(255, 255, 255, 0.6)',
                }}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d={
                            direction === 'prev'
                                ? 'M19.8087 7.23809L11.4277 16L19.8087 24.7619'
                                : 'M12.1913 24.7619L20.5723 16L12.1913 7.2381'
                        }
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        );

        const settings = {
            dots: true,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            accessibility: false,
            arrows: true,
            autoplay: true,
            variableWidth: true,
            swipeToSlide: true,
            touchThreshold: 5000,
            dotsClass: 'slick-dots bottom-[40px]',
            autoplaySpeed: 7000,
            customPaging(i) {
                return (
                    <div
                        className="w-[16px] h-[16px] rounded-full bg-gray-100"
                        style={{
                            background: '#008BAF',
                        }}
                    />
                );
            },
        };

        const handlePrev = () => {
            sliderRef.current.slickPrev();
        };

        const handleNext = () => {
            sliderRef.current.slickNext();
        };

        return isMultipleImages ? (
            <Fragment>
                <ArrowButton direction="prev" onClick={handlePrev} />
                <ArrowButton direction="next" onClick={handleNext} />
                <Slider
                    {...settings}
                    className={classNameSlider}
                    ref={sliderRef}
                >
                    {multipleImages.map(
                        (media, idx) =>
                            media && (
                                <ImageChecker
                                    src={`${folder}/${media.logo || media}`}
                                    fileType={media.fileType || null}
                                    alt=""
                                    className={className}
                                />
                            )
                    )}
                </Slider>
            </Fragment>
        ) : (
            <ImageChecker
                src={singleImageSrc}
                fileType={singleFileType}
                alt=""
                className={className}
            />
        );
    }
);

export default ImageSlider;
